export default defineNuxtRouteMiddleware((to) => {
  if (to.path.startsWith('/partners/')) return

  const runtimeConfig = useRuntimeConfig()
  const isLocal = (runtimeConfig.public.env || 'local') === 'local'

  const partnersSubCodeCookie = useCookie<string | null>('partnersSubCode', {
    secure: !isLocal,
    sameSite: isLocal ? 'lax' : 'none',
    domain: isLocal ? undefined : '.usimsa.com',
    path: '/'
  })

  partnersSubCodeCookie.value = null
})
